<p-table responsiveLayout="scroll" [value]="sections" class="mojo-admin-page data-table">
  <ng-template pTemplate="header">
    <tr>
      <th>Section</th>
      <th>
        Allowed
        <div>
          <input type="checkbox" [checked]="additionalInfoAllowAllChecked()" (change)="handleAdditionalInfoAllowAllChange($event)" />
        </div>
      </th>
      <th>
        Default
        <div>
          <input type="checkbox" [checked]="additionalInfoDefaultAllChecked()" (change)="handleAdditionalInfoDefaultAllChange($event)" />
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-section>
    <tr>
      <td>{{section.Name}}</td>
      <td><p-checkbox (onChange)="onChange(sections)" [(ngModel)]="section.Allowed" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox></td>
      <td><p-checkbox (onChange)="onChange(sections)" [(ngModel)]="section.Default" [binary]="true" [disabled]="!section.Allowed" [ngModelOptions]="{standalone: true}"></p-checkbox></td>
    </tr>
  </ng-template>
  
</p-table>
<div *ngIf="noSectionsSelected()">
  All available sections will be shown on the widget by default
</div>
